class FAQService {
  static instance: FAQService;

async getFAQ() {
    return fetch(`${import.meta.env.VITE_API_BASE_URL}faq/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

}

export default new FAQService();